import { IFormViewForm } from 'components/FormView';

const RestockingCharge: { [x: string]: IFormViewForm } = {
  RestockingCharge: {
    id: 'RestockingCharge',
    layout: {
      rows: 1,
      columns: 1,
    },
    fields: [
      {
        id: '1',
        type: 'PAPER_CONTAINER',
        visible: true,
        props: {
          name: 'activity',
          fullWidth: true,
          elevation: 0
        },
        position: {
          row: 1,
          col: 1
        },
        children: [
          {
            id: 1,
            type: 'TEXT_FIELD',
            props: {
              label: 'Credit note value',
              name: 'CreditAmount',
              size: 'medium',
              alignment: 'right',
              type: 'number',
              decimalSeparator: true,
              decimalPlaces: 2
            }
          },
          {
            id: 2,
            type: 'TEXT_FIELD',
            props: {
              label: 'Restocking by line charge',
              name: 'LineRestockingCharge',
              size: 'medium',
              alignment: 'right',
              type: 'number',
              decimalSeparator: true,
              decimalPlaces: 2
            }
          },
          {
            id: 3,
            type: 'RESTOCKING_CALCULATOR',
            props: {
              label: 'Restocking charge',
              name: 'RestockingFee',
              size: 'medium',

            }
          },
          {
            id: 4,
            type: 'TEXT_FIELD',
            props: {
              label: 'Total restocking charge',
              name: 'TotalRestockingCharge',
              size: 'medium',
              alignment: 'right',
              type: 'number',
              decimalSeparator: true,
              decimalPlaces: 2
            }
          },
          {
            id: 5,
            type: 'TEXT_FIELD',
            props: {
              label: 'Refund value',
              name: 'RefundAmount',
              size: 'medium',
              alignment: 'right',
              type: 'number',
              decimalSeparator: true,
              decimalPlaces: 2
            }
          }
        ]
      }
    ]
  }
};

export default RestockingCharge;
